import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";

import headerImg from "../../assets/images/background/13a.jpg";
import bannerBg from "../../assets/images/background/13.jpg";

import imgBanha from "../../assets/images/projects/new/banha-horr.webp";
import imgCapital from "../../assets/images/projects/new/new-capital.webp";
import img30June from "../../assets/images/projects/new/30-june.webp";
import imgFangary from "../../assets/images/projects/new/fangary.webp";
import imgObour from "../../assets/images/projects/new/obour.webp";
import imgBadr from "../../assets/images/projects/new/badr.webp";
import iconRoad from "../../assets/icons/ROAD.webp";
import iconBuilding from "../../assets/icons/building-icon.webp";

import cert5 from "../../assets/images/quality/certifications/5.png";
import cert6 from "../../assets/images/quality/certifications/6.png";
import cert7 from "../../assets/images/quality/certifications/7.png";
import cert8 from "../../assets/images/quality/certifications/8.png";
import cert9 from "../../assets/images/quality/certifications/9.png";

import consult1j from "../../assets/images/quality/certifications/1.jpg";
import consult2j from "../../assets/images/quality/certifications/2.jpg";
import consult3j from "../../assets/images/quality/certifications/3.jpg";
import consult4j from "../../assets/images/quality/certifications/4.jpg";
import consult1p from "../../assets/images/quality/certifications/1.png";
import consult2p from "../../assets/images/quality/certifications/2.png";
import consult3p from "../../assets/images/quality/certifications/3.png";
import consult4p from "../../assets/images/quality/certifications/4.png";



const projects = [
  { image: imgBanha,   nameKey: "project-1-name", bodyKey: "project-1-body", icon: iconRoad },
  { image: imgCapital, nameKey: "project-2-name", bodyKey: "project-2-body", icon: iconBuilding },
  { image: img30June,  nameKey: "project-3-name", bodyKey: "project-3-body", icon: iconRoad },
  { image: imgFangary, nameKey: "project-4-name", bodyKey: "project-4-body", icon: iconRoad },
  { image: imgObour,   nameKey: "project-5-name", bodyKey: "project-5-body", icon: iconBuilding },
  { image: imgBadr,    nameKey: "project-6-name", bodyKey: "project-6-body", icon: iconBuilding },
];

const accreCerts = [cert5, cert6, cert7, cert8, cert9];
const consultCerts = [
  consult1j, consult1p, consult2j, consult2p,
  consult3j, consult3p, consult4j, consult4p,
  cert5, cert6, cert7, cert8, cert9,
];
const accreDup = [...accreCerts, ...accreCerts];
const consultDup = [...consultCerts, ...consultCerts];

function Projects() {
  const { t } = useTranslation();

  /* Mega Projects */
  const mpLabelRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const mpHeadRef  = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const mpIntroRef = useAnimateCss("animate__fadeInUp",   220, 0.15);
  const gridRef    = useAnimateCssStagger("animate__fadeInUp", 100, 0.06);

  /* Accreditation section */
  const acc1LabelRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const acc1HeadRef  = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const acc1IntroRef = useAnimateCss("animate__fadeInUp",   220, 0.15);
  const acc1TrackRef = useAnimateCss("animate__fadeIn",     300, 0.1,  900);

  /* 50-years banner */
  const bannerRef    = useAnimateCss("animate__zoomIn", 0, 0.15, 700);

  /* Consulting approvals section */
  const acc2LabelRef = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const acc2HeadRef  = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const acc2IntroRef = useAnimateCss("animate__fadeInUp",   220, 0.15);
  const acc2TrackRef = useAnimateCss("animate__fadeIn",     300, 0.1,  900);

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("Projects")} />

      {/* ── Mega Projects ── */}
      <section className="mega-projects-section">
        <div className="container">
          <span className="page-section-label" ref={mpLabelRef as any}>{t("Projects")}</span>
          <h2 className="inner-page-heading" ref={mpHeadRef as any}>{t("Mega Projects")}</h2>
          <p className="mega-projects-intro" ref={mpIntroRef as any}>
            {t("Our Steel Rebar approved and supplied in Iconic Construction sites in Egypt :")}
          </p>

          <div className="row g-4 mt-2" ref={gridRef as any}>
            {projects.map((p, i) => (
              <div key={i} className="col-lg-6">
                <Link
                  to="/projects/mega-projects"
                  className="pg-card"
                  aria-label={t(p.nameKey)}
                >
                  <div className="pg-card-header">
                    <div className="pg-card-icon">
                      <img src={p.icon} alt="" />
                    </div>
                    <h6 className="pg-card-title">{t(p.nameKey)}</h6>
                  </div>
                  <p className="pg-card-desc">{t(p.bodyKey)}</p>
                  <img src={p.image} alt={t(p.nameKey)} className="pg-card-img" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Product Accreditation ── */}
      <section className="projects-cert-section">
        <div className="container">
          <span className="page-section-label" ref={acc1LabelRef as any}>{t("Accreditation & Approvals")}</span>
          <h2 className="inner-page-heading" ref={acc1HeadRef as any}>{t("Product accreditation")}</h2>
          <p className="cert-intro" ref={acc1IntroRef as any}>{t("accreditation-text")}</p>
        </div>

        {/* <div className="projects-cert-marquee-wrapper" ref={acc1TrackRef as any}>
          <div className="projects-cert-fade projects-cert-fade--left" />
          <div className="projects-cert-fade projects-cert-fade--right" />
          <div className="projects-cert-track projects-cert-track--slow">
            {accreDup.map((src, i) => (
              <a key={i} href={src} target="_blank" rel="noreferrer" className="projects-cert-item">
                <img src={src} alt={`Certificate ${(i % accreCerts.length) + 1}`} />
              </a>
            ))}
          </div>
        </div> */}
      </section>

      {/* ── 50 Years banner ── */}
      <div
        className="projects-years-banner"
        style={{ backgroundImage: `url(${bannerBg})` }}
        ref={bannerRef as any}
      >
        <span className="projects-years-text">{t("50 years of experience")}</span>
      </div>

      {/* ── Consulting Engineering Approvals ── */}
      <section className="projects-cert-section">
        <div className="container">
          <span className="page-section-label" ref={acc2LabelRef as any}>{t("Certifications")}</span>
          <h2 className="inner-page-heading" ref={acc2HeadRef as any}>{t("Consulting engineering approvals")}</h2>
          <p className="cert-intro" ref={acc2IntroRef as any}>{t("accreditation-info")}</p>
        </div>

        {/* <div className="projects-cert-marquee-wrapper" ref={acc2TrackRef as any}>
          <div className="projects-cert-fade projects-cert-fade--left" />
          <div className="projects-cert-fade projects-cert-fade--right" />
          <div className="projects-cert-track projects-cert-track--fast">
            {consultDup.map((src, i) => (
              <a key={i} href={src} target="_blank" rel="noreferrer" className="projects-cert-item">
                <img src={src} alt={`Approval ${(i % consultCerts.length) + 1}`} />
              </a>
            ))}
          </div>
        </div> */}
      </section>

      <Footer />
    </>
  );
}

export default Projects;
